export default __webpack_public_path__ + "static/logoDataboxBlack-84bc348d3a12e8c2b928641e312ffdb2.png";